import ApiService from '@/services/api';
import { EntityBuilder } from '@decahedron/entity';
import Message from '@/entities/Message';
import Sell from '@/entities/Sell';

let instance: MessageService = null;

export default class MessageService {
  apiService: ApiService = null;

  constructor() {
    if (!instance) {
      this.apiService = new ApiService();
      instance = this;
    }

    return instance;
  }

  list() {
    return this.apiService.get('messages')
      .then((response) => EntityBuilder.buildMany<Message>(Message, response.data));
  }

  listSells() {
    return this.apiService.get('sell')
      .then((response) => EntityBuilder.buildMany<Sell>(Sell, response.data));
  }

  find(id: string) {
    return this.apiService.get(`messages/${id}`)
      .then((response) => EntityBuilder.buildOne(Message, response.data));
  }
}
